export default class UpdateVigenciaReferencia {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute(idPersonal, idReferencia) {
    return await this.#repository.setVigencia(idPersonal, idReferencia)
  }
}
